import { useState, type ReactNode } from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export function MaintenanceListToolbar({
  children,
  extra,
  extraCount = 0,
  filtered = false,
  onReset,
}: {
  children: ReactNode;
  extra?: ReactNode;
  extraCount?: number;
  filtered?: boolean;
  onReset?: () => void;
}) {
  const [opened, setOpened] = useState(false);
  const expanded = extraCount > 0 || opened;

  return (
    <Card className="gap-0 py-0 shadow-sm">
      <div className="flex flex-col gap-3 p-3 sm:p-4">
        <div className="flex flex-wrap items-end gap-3">
          <div className="grid min-w-0 flex-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">{children}</div>
          {extra || (filtered && onReset) ? (
            <div className="flex flex-wrap items-center gap-2">
              {extra ? (
                <Button
                  type="button"
                  variant="outline"
                  className="min-h-11"
                  aria-expanded={expanded}
                  onClick={() => {
                    if (extraCount > 0) {
                      setOpened(true);
                      return;
                    }
                    setOpened((current) => !current);
                  }}
                >
                  Weitere Filter
                  {extraCount > 0 ? <Badge variant="secondary">{extraCount}</Badge> : null}
                </Button>
              ) : null}
              {filtered && onReset ? (
                <Button type="button" variant="ghost" className="min-h-11" onClick={onReset}>
                  Zurücksetzen
                </Button>
              ) : null}
            </div>
          ) : null}
        </div>
        {extra && expanded ? (
          <div className="grid min-w-0 gap-3 border-t border-border pt-3 sm:grid-cols-2 lg:grid-cols-3">
            {extra}
          </div>
        ) : null}
      </div>
    </Card>
  );
}
